import { render, staticRenderFns } from "./NominateForm.vue?vue&type=template&id=5c015300&scoped=true&"
import script from "./NominateForm.vue?vue&type=script&lang=js&"
export * from "./NominateForm.vue?vue&type=script&lang=js&"
import style0 from "./NominateForm.vue?vue&type=style&index=0&id=5c015300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c015300",
  null
  
)

export default component.exports